document.addEventListener('DOMContentLoaded', function () {
    productPage.init();
    collectionPage.init();
    pandaPrivacyBanner.init()

    // const navInjector = new NavigationInjector();
    // navInjector.init();
});
const productPage = {
    init: function () {
        const isOnProductPage = $('.template-product').length > 0;
        if (!isOnProductPage) {
            return
        }
        this.addEventListeners()
    }, addEventListeners: function () {
        $(document).on('cartUpdated', async function (e, cartContent) {
            const currentCartValue = await theme.PandaCart.getCurrentCartValue(cartContent);
            const currentText = await theme.PandaCart.getShippingCostText(currentCartValue);
            $('.ShippingText').text(currentText)
        });
        $(window).on('cc-variant-updated', function (e, opts) {

            // Load variant metafields
            let variantMetafields = {};
            try {
                const metafieldsJson = document.getElementById('VariantMetafieldsJson');
                if (metafieldsJson) {
                    variantMetafields = JSON.parse(metafieldsJson.textContent);
                }
            } catch (error) {
                console.error('[Variant Title] Error parsing variant metafields:', error);
            }

            const allVariantOptions = [3];
            for (const variant of opts.product.variants) {
                for (let i = 0; i < variant.options.length; i += 1) {
                    if (!(allVariantOptions[i] && allVariantOptions[i].length > 0)) {
                        allVariantOptions[i] = []
                    }
                    if (!allVariantOptions[i].includes(variant.options[i])) {
                        allVariantOptions[i].push(variant.options[i])
                    }
                }
            }

            const options = opts.variant.options;
            const variantId = opts.variant.id;
            const variantMeta = variantMetafields[variantId] || {};


            let titlePrefix = '';
            for (let i = 0; i < options.length; i += 1) {
                if (allVariantOptions[i].length > 1) {
                    const optionName = opts.product.options[i];
                    let optionValue = options[i];


                    // Use metafield value if option is "Modell" or "Größe"
                    if (optionName === 'Modell' && variantMeta.model_title_part) {
                        optionValue = variantMeta.model_title_part;
                    } else if (optionName === 'Größe' && variantMeta.size_title_part) {
                        optionValue = variantMeta.size_title_part;
                    }

                    titlePrefix += ' - ' + optionValue;
                }
            }

            $('.variant-product-title').html(titlePrefix)
        })
    }
};
const collectionPage = {
    init: function () {
        const isOnCollectionPage = $('.template-collection').length > 0;
        if (!isOnCollectionPage) {
            return
        }
        this.addEventListeners()
    }, addEventListeners: function () {
        // Boost 8.1.0 tauscht beim AJAX-Filtern nur Filterleiste und Ergebnisse aus,
        // nicht den H1 - Titel daher wie collection-filter-title.liquid nachziehen.
        document.addEventListener('filters-applied', function () {
            const labels = [];
            document.querySelectorAll('.cc-facet-filters input[name^="filter.p"]:checked').forEach(function (input) {
                const label = document.querySelector('label[for="' + input.id + '"] .cc-filter-label');
                if (label) labels.push(label.textContent.trim());
            });
            const text = labels.length < 3 ? labels.join(' ') : '';
            document.querySelectorAll('.p-selected-filters').forEach(function (el) {
                el.textContent = text;
            });
        })
    }
};
const pandaPrivacyBanner = {
    // Markiert <html> mit .panda-consent-open, solange Shopifys Cookie-Banner
    // offen ist (panda-custom.css blendet dann das Trusted-Shops-Siegel aus).
    // Ersetzt ein body:has(#shopify-pc__banner…), das bei jeder DOM-Änderung
    // die Styles der ganzen Seite neu berechnen ließ. Shopify hängt den Banner
    // asynchron ein und schließt ihn per style="display: none".
    init: function () {
        const html = document.documentElement;
        const watchBanner = function (banner) {
            const update = function () {
                html.classList.toggle('panda-consent-open', banner.style.display !== 'none');
            };
            update();
            new MutationObserver(update).observe(banner, {attributes: true, attributeFilter: ['style']});
        };
        const banner = document.getElementById('shopify-pc__banner');
        if (banner) {
            watchBanner(banner);
            return;
        }
        const waitForBanner = new MutationObserver(function () {
            const banner = document.getElementById('shopify-pc__banner');
            if (banner) {
                waitForBanner.disconnect();
                watchBanner(banner);
            }
        });
        waitForBanner.observe(document.body, {childList: true, subtree: true});
        // Kommt kein Banner (Consent schon erteilt), nicht ewig mitlauschen.
        setTimeout(function () { waitForBanner.disconnect(); }, 15000);
    }, trackingDeclined: function () {
        const privacyCookie = $.cookie('_tracking_consent');
        if (!privacyCookie) {
            return false
        }
        const privacyCookieParsed = JSON.parse(privacyCookie);
        const trackingAllowed = privacyCookieParsed.con.CMP.a === "1" || privacyCookieParsed.con.CMP.a === 1
        return !trackingAllowed;
    }
};
const helper = {
    isMobile: function () {
        return window.matchMedia('only screen and (max-width: 768px)').matches
    }
};

/* ==========================================================================
   PANDA: Cart helpers + add-to-cart hooks (kept out of stock theme.js so
   stock files stay untouched during theme updates).
   ========================================================================== */
theme.PandaCart = {
    cachedCartContent: null,
    getCartContents: async function getCartContents(forceReload) {
        if (this.cachedCartContent != null && !forceReload) {
            return this.cachedCartContent
        }
        const data = await fetch(window.Shopify.routes.root + 'cart.js').then(response => response.json());
        this.cachedCartContent = data;
        return data
    },
    updateCartItemQuantity: async function updateCartItemQuantity(key, quantity) {
        const url = window.Shopify.routes.root + 'cart/change.js';
        const options = {
            method: 'POST',
            body: JSON.stringify({'id': key, 'quantity': quantity}),
            headers: {'Content-Type': 'application/json'}
        };
        await fetch(url, options);
        this.cachedCartContent = null;
    },
    getCurrentCartValue: async function getCurrentCartValue(cartContent) {
        return cartContent.total_price
    },
    getShippingCostText: async function getShippingCostText(currentCartValue) {
        const freeShippingPrice = theme.settings.freeShippingPrice * 100;
        if (currentCartValue < 0.1) {
            return theme.strings.noCartContent.replace('[price]', theme.Shopify.formatMoney(freeShippingPrice, theme.moneyFormat))
        } else if (currentCartValue < freeShippingPrice) {
            return theme.strings.shippingCostsNotReached.replace('[remaining_amount]', theme.Shopify.formatMoney(freeShippingPrice - currentCartValue, theme.moneyFormat))
        } else {
            return theme.strings.shippingCostsReached
        }
    },
    getFreeShippingPrice: function getFreeShippingPrice() {
        return theme.settings.freeShippingPrice * 100
    },
    getShippingIsFree: async function getShippingIsFree(currentCartValue) {
        const freeShippingPrice = theme.settings.freeShippingPrice * 100;
        return currentCartValue >= freeShippingPrice
    }
};

/* Header cart count follows every cart change: adding from the product page
   and changing or removing items in the floating cart. */
$(document).on('cartUpdated', function (e, cartContent) {
    $('.header-cart__count').text(cartContent.item_count)
});

/* After the stock ProductForm handler adds an item to the cart, refresh the
   free-shipping text, header cart count and floating cart.

   The stock handler posts to cart/add.js and fires no event of its own when
   the item has landed, so this used to hang on the form's submit and wait a
   fixed 600ms. On mobile that guess was regularly too short: cart.js was then
   still answering with the cart from *before* the add, which left the side and
   floating cart rendering an empty cart next to a header count of 1 -- and the
   stale response was cached on top of that. jQuery's global ajaxSuccess lets
   us react to the actual cart/add response instead, without patching theme.js. */
$(document).on('ajaxSuccess', async function (e, xhr, settings) {
    const addUrl = theme.routes && theme.routes.cart_add_url;
    if (!addUrl || !settings || typeof settings.url !== 'string') { return }
    if (settings.url.split('?')[0].indexOf(addUrl) !== 0) { return }
    try {
        const cartContent = await theme.PandaCart.getCartContents(true);
        const currentCartValue = await theme.PandaCart.getCurrentCartValue(cartContent);
        const currentText = await theme.PandaCart.getShippingCostText(currentCartValue);
        if ($('.ShippingText').length > 0) {
            $('.ShippingText').text(currentText)
        }
        $(document).trigger('cartUpdated', cartContent);
        if (typeof toggleFloatingCart === 'function') {
            toggleFloatingCart()
        }
    } catch (e) {
        console.warn('[Panda] cart refresh failed', e)
    }
});

/* ==========================================================================
   PANDA: Show the "adding to cart" label before the main thread stalls.

   theme.js already swaps the button label on submit, but from that moment on
   it and the Aftersell app occupy the main thread, so the browser only gets
   around to painting the new label once the upsell popup is already open --
   far too late to read as feedback. Doing the swap on pointerdown gives it a
   frame while the mouse button is still down.

   The label itself, the disabled state and the revert stay with the stock
   handler; this only moves the moment it becomes visible.
   ========================================================================== */
(function () {
    /* Long enough for the submit to follow a normal click. */
    const SUBMIT_GRACE_MS = 600;
    const BUSY_CLASS = 'is-panda-busy';
    /* The stock handler reverts the button after 1000ms; clear just after. */
    const BUSY_CLEAR_MS = 1500;

    let $pending = null;
    let $label = null;
    let originalLabel = null;
    let originalHtml = null;

    function reset() {
        $pending = null;
        $label = null;
        originalLabel = null;
        originalHtml = null
    }

    function restore() {
        if (!$pending) { return }
        $label.text(originalLabel);
        $pending.removeClass(BUSY_CLASS);
        reset()
    }

    $(document).on('pointerdown', '[data-add-to-cart]', function () {
        const $btn = $(this);
        const label = theme.strings && theme.strings.addingToCart;
        if (!label || $pending || $btn.prop('disabled')) { return }
        /* Only the text inside the existing span, never $btn.html(): replacing
           the button's markup would remove the element this pointerdown
           happened on, and the browser would then never fire the click that
           submits the form. */
        const $span = $btn.find('[data-add-to-cart-text]');
        if (!$span.length) { return }
        $pending = $btn;
        $label = $span;
        originalLabel = $span.text();
        originalHtml = $btn.html();
        $span.text(label);
        /* Greyed out via class, not the disabled attribute: a disabled button
           fires no click, so the form would never be submitted. The stock
           handler sets the real disabled state a moment later. */
        $btn.addClass(BUSY_CLASS)
    });

    /* No submit followed -- click cancelled or a required field is empty. */
    $(document).on('pointerup', function () {
        setTimeout(restore, SUBMIT_GRACE_MS)
    });

    $(document).on('submit', 'product-form form', function () {
        if (!$pending) { return }
        /* The stock handler runs first (it is bound to the form, this one to
           the document) and has just stored our replacement as
           previous-value. Put the original markup back, otherwise the button
           keeps saying "adding to cart" after the revert. */
        const $btn = $pending;
        $pending.data('previous-value', originalHtml);
        setTimeout(function () { $btn.removeClass(BUSY_CLASS) }, BUSY_CLEAR_MS);
        reset()
    });
})();

/* ==========================================================================
   PANDA: Variant engine. Ported from the legacy Boost theme.js so that the
   stock 8.1.0 theme.js stays untouched. Handles option select changes,
   price/SKU/media updates, history state and the cc-variant-updated /
   theme:variant-updated events used by panda scripts and the
   panda-theme-app blocks.
   ========================================================================== */
(function () {
    if (window.pandaVariantsInitialized) {
        return
    }
    window.pandaVariantsInitialized = true;

    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.secondaryIdSelectors = options.secondaryIdSelectors;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();
        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this))
    }

    Variants.prototype = $.extend({}, Variants.prototype, {
        _getCurrentOptions: function _getCurrentOptions() {
            var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
                var $element = $(element);
                var type = $element.attr('type');
                var currentOption = {};
                if (type === 'radio' || type === 'checkbox') {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');
                        return currentOption
                    } else {
                        return false
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');
                    return currentOption
                }
            });
            return currentOptions.filter(Boolean)
        },
        _getVariantFromOptions: function _getVariantFromOptions() {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = false;
            variants.forEach(function (variant) {
                var satisfied = true;
                selectedValues.forEach(function (option) {
                    if (satisfied) {
                        satisfied = option.value === variant[option.index]
                    }
                });
                if (satisfied) {
                    found = variant
                }
            });
            return found || null
        },
        _onSelectChange: function _onSelectChange() {
            var variant = this._getVariantFromOptions();
            this.$container.trigger({type: 'variantChange', variant: variant});
            if (!variant) {
                this._updateSecondarySelects(variant);
                return
            }
            $(window).trigger('cc-variant-updated', {variant: variant, product: this.product});
            // Also dispatch for panda-theme-app blocks
            window.dispatchEvent(new CustomEvent('theme:variant-updated', {detail: {variant: variant, product: this.product}}));
            this._updateMasterSelect(variant);
            this._updateSecondarySelects(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this.currentVariant = variant;
            if (this.enableHistoryState) {
                this._updateHistoryState(variant)
            }
        },
        _updateImages: function _updateImages(variant) {
            var variantMedia = variant.featured_media || {};
            var currentVariantMedia = this.currentVariant.featured_media || {};
            if (!variant.featured_media || variantMedia.id === currentVariantMedia.id) {
                return
            }
            this.$container.trigger({type: 'variantImageChange', variant: variant})
        },
        _updatePrice: function _updatePrice(variant) {
            var hasChanged = false;
            if (variant.price !== this.currentVariant.price || variant.compare_at_price !== this.currentVariant.compare_at_price || variant.unit_price_measurement !== this.currentVariant.unit_price_measurement || variant.unit_price_measurement && (variant.unit_price !== this.currentVariant.unit_price || variant.unit_price_measurement.reference_value !== this.currentVariant.unit_price_measurement.reference_value || variant.unit_price_measurement.reference_unit !== this.currentVariant.unit_price_measurement.reference_unit)) {
                hasChanged = true
            }
            if (!hasChanged) {
                return
            }
            this.$container.trigger({type: 'variantPriceChange', variant: variant})
        },
        _updateHistoryState: function _updateHistoryState(variant) {
            if (!history.replaceState || !variant) {
                return
            }
            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({path: newurl}, '', newurl)
        },
        _updateMasterSelect: function _updateMasterSelect(variant) {
            var select = $(this.originalSelectorId, this.$container)[0];
            if (!select) {
                return
            }
            select.value = variant.id;
            select.dispatchEvent(new Event('change', {bubbles: true, cancelable: false}))
        },
        _updateSecondarySelects: function _updateSecondarySelects(variant) {
            $(this.secondaryIdSelectors, this.$container).each(function () {
                this.value = variant ? variant.id : null;
                this.dispatchEvent(new Event('change', {bubbles: true, cancelable: false}))
            })
        }
    });

    theme.variants = {
        selectors: {
            originalSelectorId: '[data-product-select]',
            secondaryIdSelectors: '[data-product-secondary-select]',
            priceWrapper: '[data-price-wrapper]',
            productPrice: '[data-product-price]',
            addToCart: '[data-add-to-cart]',
            addToCartText: '[data-add-to-cart-text]',
            comparePrice: '[data-compare-price]',
            comparePriceText: '[data-compare-text]',
            unitPrice: '.unit-price'
        },
        updateAddToCartState: function updateAddToCartState(evt) {
            var variant = evt.variant;
            if (variant) {
                $(theme.variants.selectors.priceWrapper, this.$container).removeClass('hide')
            } else {
                $(theme.variants.selectors.addToCart, this.$container).prop('disabled', true);
                $(theme.variants.selectors.addToCartText, this.$container).html(theme.strings.unavailable);
                $(theme.variants.selectors.priceWrapper, this.$container).addClass('hide');
                return
            }
            if (variant.available) {
                $(theme.variants.selectors.addToCart, this.$container).prop('disabled', false);
                $(theme.variants.selectors.addToCartText, this.$container).html(theme.strings.addToCart);
                $('form', this.$container).removeClass('variant--unavailable')
            } else {
                $(theme.variants.selectors.addToCart, this.$container).prop('disabled', true);
                $(theme.variants.selectors.addToCartText, this.$container).html(theme.strings.soldOut);
                $('form', this.$container).addClass('variant--unavailable')
            }
            var $backorderContainer = $('.backorder', this.$container);
            if ($backorderContainer.length) {
                if (variant && variant.available) {
                    var $option = $(theme.variants.selectors.originalSelectorId + ' option[value="' + variant.id + '"]', this.$container);
                    if (variant.inventory_management && $option.data('stock') == 'out') {
                        $backorderContainer.find('.backorder__variant').html(this.productSingleObject.title + (variant.title.indexOf('Default') >= 0 ? '' : ' - ' + variant.title));
                        $backorderContainer.show()
                    } else {
                        $backorderContainer.hide()
                    }
                } else {
                    $backorderContainer.hide()
                }
            }
        },
        updateProductPrices: function updateProductPrices(evt) {
            var variant = evt.variant;
            var $comparePrice = $(theme.variants.selectors.comparePrice, this.$container);
            var $compareEls = $comparePrice.add(theme.variants.selectors.comparePriceText, this.$container);
            var $price = $(theme.variants.selectors.productPrice, this.$container);
            var $unitPrice = $(theme.variants.selectors.unitPrice, this.$container);
            $price.html('<span class="theme-money large-title">' + theme.Shopify.formatMoney(variant.price, theme.moneyFormat) + '</span>');
            if (variant.compare_at_price > variant.price) {
                $price.addClass('product-price__reduced');
                $comparePrice.html('<span class="product-price__compare theme-money">' + theme.Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat) + '</span>');
                $compareEls.removeClass('hide')
            } else {
                $price.removeClass('product-price__reduced');
                $comparePrice.html('');
                $compareEls.addClass('hide')
            }
            if (variant.unit_price_measurement) {
                var $newUnitPriceArea = $('<div class="unit-price small-text">');
                $('<span class="unit-price__price theme-money">').html(theme.Shopify.formatMoney(variant.unit_price, theme.moneyFormat)).appendTo($newUnitPriceArea);
                $('<span class="unit-price__separator">').html(theme.strings.unitPriceSeparator).appendTo($newUnitPriceArea);
                $('<span class="unit-price__unit">').html(theme.variants.getBaseUnit(variant)).appendTo($newUnitPriceArea);
                if ($unitPrice.length) {
                    $unitPrice.replaceWith($newUnitPriceArea)
                } else {
                    $(theme.variants.selectors.priceWrapper, this.$container).append($newUnitPriceArea)
                }
            } else {
                $unitPrice.remove()
            }
        },
        getBaseUnit: function getBaseUnit(variant) {
            return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit
        }
    };

    function updateSKU(evt) {
        var variant = evt.variant;
        if (variant && variant.sku) {
            $('.sku-wrapper', this.$container).removeClass('sku-wrapper--empty');
            $('.sku-wrapper__sku', this.$container).html(variant.sku)
        } else {
            $('.sku-wrapper', this.$container).addClass('sku-wrapper--empty');
            $('.sku-wrapper__sku', this.$container).empty()
        }
    }

    function updatePrimaryProductMediaFromThumbnail($mediaWithId) {
        var index = this.$productMedia.filter('[data-media-id="' + $mediaWithId.data('media-id') + '"]').closest('.slick-slide').data('slick-index');
        this.$productMediaContainer.slick('slickGoTo', index)
    }

    function updateProductMediaSlideshowFromVariantChange(evt) {
        var variant = evt.variant;
        var $found = this.$productMedia.filter(function () {
            return $(this).data('media-id') == variant.featured_media.id
        });
        if ($found.length == 1) {
            updatePrimaryProductMediaFromThumbnail.call(this, $found)
        }
    }

    function updateProductMediaColumn(evt) {
        var variant = evt.variant;
        var $found = this.$productMedia.filter(function () {
            return $(this).data('media-id') == variant.featured_media.id
        });
        if ($found.length == 1) {
            if (this.$productMediaContainer.hasClass('slick-slider')) {
                updatePrimaryProductMediaFromThumbnail.call(this, $found)
            } else {
                clearTimeout(this.variantScrollTimeoutId);
                this.variantScrollTimeoutId = setTimeout(function () {
                    var desiredScrollTop = $found.offset().top - theme.dockedNavHeight();
                    var $cont = $found.closest('.product-detail');
                    var maxScrollTop = $cont.offset().top + $cont.height() - $cont.find('.product-detail__detail').outerHeight() - 20;
                    $('html,body').animate({scrollTop: Math.min(desiredScrollTop, maxScrollTop)}, 500, function () {
                        $found.removeClass('variant-dim');
                        this.$productImages.not($found).addClass('variant-dim variant-dim--fixed');
                        setTimeout(function () {
                            $('.variant-dim--fixed').removeClass('variant-dim--fixed')
                        }, 500)
                    }.bind(this))
                }.bind(this), 25)
            }
        }
    }

    function initProductVariants(container) {
        var $container = $(container);
        var namespace = theme.namespaceFromSection(container);
        if (!namespace) {
            namespace = '.panda-variants-' + $container.attr('data-section-id')
        }
        var $productJson = $('[data-product-json]', $container);
        if (!$productJson.html()) {
            return
        }
        var productSingleObject = JSON.parse($productJson.html());
        var options = {
            $container: $container,
            enableHistoryState: $container.data('enable-history-state') || false,
            singleOptionSelector: '[data-single-option-selector]',
            originalSelectorId: theme.variants.selectors.originalSelectorId,
            secondaryIdSelectors: theme.variants.selectors.secondaryIdSelectors,
            product: productSingleObject
        };
        var ctx = {
            $container: $container,
            productSingleObject: productSingleObject,
            $productMediaContainer: $('.product-detail__images', $container),
            $productMedia: $('[data-product-media]', $container),
            $productImages: $('[data-product-image]', $container),
            $productMediaThumbnails: $('[data-product-media-thumbnail]', $container)
        };
        var variants = new Variants(options);
        $container.on('variantChange' + namespace, theme.variants.updateAddToCartState.bind(ctx));
        $container.on('variantPriceChange' + namespace, theme.variants.updateProductPrices.bind(ctx));
        if ($('.sku-wrapper', $container).length) {
            $container.on('variantChange' + namespace, updateSKU.bind(ctx))
        }
        if (ctx.$productMediaThumbnails.length && ctx.$productMedia.length > 1) {
            $container.on('variantImageChange' + namespace, updateProductMediaSlideshowFromVariantChange.bind(ctx))
        } else if (ctx.$productMedia.length > 1) {
            $container.on('variantImageChange' + namespace, updateProductMediaColumn.bind(ctx))
        }
        // initial events (panda variant title + panda-theme-app blocks)
        $(window).trigger('cc-variant-updated', {variant: variants.currentVariant, product: productSingleObject});
        window.dispatchEvent(new CustomEvent('theme:variant-updated', {detail: {variant: variants.currentVariant, product: productSingleObject}}));
        $container.data('panda-variants', variants)
    }

    function init() {
        $('[data-section-type="product"]').each(function () {
            initProductVariants(this)
        })
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init)
    } else {
        init()
    }
})();

/* Initial cart load: trigger cartUpdated on page load so the permanent
   side cart (Amazon-style) shows when the cart has items. */
document.addEventListener('DOMContentLoaded', async function () {
    try {
        const cartContent = await theme.PandaCart.getCartContents();
        $(document).trigger('cartUpdated', cartContent)
    } catch (e) {
        console.warn('[Panda] initial cart load failed', e)
    }
});

/* ==========================================================================
   PANDA: Mobile accordions on the product page.

   The panels (product description, motif, product information, ...) are
   display:none in panda-custom.css and were opened by a click handler that
   used to live in the old theme.js. That handler did not survive the move to
   8.1.0, which left the accordion headings on mobile completely dead.
   Delegated here so panels rendered after page load work too.
   ========================================================================== */
$(document).on('click', '.accordion', function () {
    const panel = this.nextElementSibling;
    if (!panel) { return }
    /* Only one panel open at a time. */
    $('.accordion').each(function () {
        const other = this.nextElementSibling;
        if (!other || other.id === panel.id) { return }
        this.classList.remove('active');
        other.style.display = 'none'
    });
    /* Computed style, not the inline one: the first panel starts open via
       .tab-content--active and would otherwise need two clicks to close. */
    const isOpen = window.getComputedStyle(panel).display === 'block';
    this.classList.toggle('active');
    panel.style.display = isOpen ? 'none' : 'block'
});

/* ==========================================================================
   PANDA: Landing sections — buttons that jump back up to the design box
   (photo upload of the panda-theme-app). .ai-custom-image-react-root is the
   mount point the app block renders in Liquid, so it is a stable target.
   ========================================================================== */
$(document).on('click', '[data-panda-scroll-to-designer]', function () {
    const designer = document.querySelector('.ai-custom-image-react-root');
    if (designer) {
        designer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return
    }
    const titleArea = document.querySelector('.product-detail__title-area');
    if (titleArea) { titleArea.scrollIntoView({ behavior: 'smooth', block: 'start' }) }
});

/* Sticky bar without anything to choose: hand the tap to the real button, so
   the product form, its checks and the cart apps run exactly as usual. */
$(document).on('click', '[data-panda-sticky-add]', function () {
    const button = document.querySelector('.product-detail .btn-add-to-cart');
    if (button) { button.click() }
});

/* Sticky bar: shown once the buy button has been scrolled past upwards, so
   it only appears when the button is out of reach. The observer's root
   reaches far below the viewport, so "not intersecting" means "above" and
   a jump straight back to the top still reports the button. On
   personalised products the add-to-cart button is hidden and "Jetzt
   anpassen" takes its place; a hidden button never counts as passed, so
   both are watched. The bar steps aside while the footer is in view, so it
   never covers Impressum, Datenschutz and the other legal links. */
(function () {
    const bar = document.querySelector('[data-panda-sticky-cta]');
    const buttons = document.querySelectorAll('.product-detail .btn-add-to-cart, .product-detail .PersonalisationModalBtn');
    if (!bar || !buttons.length || !('IntersectionObserver' in window)) { return }
    const footer = document.querySelector('.page-footer');
    const passed = new Set();
    let footerInView = false;
    function update() {
        const open = passed.size > 0 && !footerInView;
        bar.classList.toggle('is-visible', open);
        document.body.classList.toggle('pl-sticky-open', open)
    }
    bar.hidden = false;
    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
                passed.add(entry.target)
            } else {
                passed.delete(entry.target)
            }
        });
        update()
    }, { rootMargin: '0px 0px 100000px 0px' });
    buttons.forEach(function (button) { observer.observe(button) });
    if (footer) {
        new IntersectionObserver(function (entries) {
            footerInView = entries[0].isIntersecting;
            update()
        }).observe(footer)
    }
})();

/* PANDA: FAQ-Hub (panda-faq-hub) - den Abschnitt, der gerade im Blick ist,
   in der Unternavigation markieren und auf dem Handy die Pille in den
   sichtbaren Bereich der wischbaren Leiste schieben */
document.addEventListener('DOMContentLoaded', function () {
    const hub = document.querySelector('[data-panda-faq-hub]');
    if (!hub || !('IntersectionObserver' in window)) {
        return;
    }
    const nav = hub.querySelector('.panda-faq-hub__nav');
    const links = {};
    hub.querySelectorAll('.panda-faq-hub__nav-link').forEach(function (link) {
        links[decodeURIComponent(link.hash.slice(1))] = link;
    });

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            const link = links[entry.target.id];
            if (!entry.isIntersecting || !link) {
                return;
            }
            Object.keys(links).forEach(function (id) {
                links[id].classList.toggle('is-active', links[id] === link);
            });
            nav.scrollTo({ left: link.offsetLeft - (nav.clientWidth - link.offsetWidth) / 2, behavior: 'smooth' });
        });
    }, { rootMargin: '-35% 0px -60% 0px' });

    hub.querySelectorAll('.panda-faq-hub__topic[id]').forEach(function (topic) {
        observer.observe(topic);
    });
});

/* ==========================================================================
   PANDA: Trusted Shops reviews (snippets/shop-review.liquid). Summary with
   average and count of all reviews; below, only the reviews with a text as
   cards, newest first, six at a time. Comments go in as text, not HTML.
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
    const PAGE_SIZE = 6;

    function stars(mark) {
        const rounded = Math.round(mark);
        return '★★★★★'.slice(0, rounded) + '☆☆☆☆☆'.slice(0, 5 - rounded);
    }

    function formatDate(value) {
        const date = new Date(value);
        if (isNaN(date)) { return '' }
        return String(date.getUTCDate()).padStart(2, '0') + '.'
            + String(date.getUTCMonth() + 1).padStart(2, '0') + '.'
            + date.getUTCFullYear();
    }

    document.querySelectorAll('[data-panda-reviews]').forEach(function (root) {
        let reviews = [];
        try {
            reviews = JSON.parse(root.querySelector('[data-panda-reviews-json]').textContent || '[]');
        } catch (error) {
            return;
        }
        if (!Array.isArray(reviews) || !reviews.length) { return }

        const marks = reviews.map(function (review) { return Number(review.mark) || 0 });
        const average = marks.reduce(function (sum, mark) { return sum + mark }, 0) / marks.length;
        const summary = root.querySelector('.panda-reviews__summary');
        summary.querySelector('.panda-reviews__score').textContent = average.toFixed(1).replace('.', ',');
        summary.querySelector('.panda-reviews__stars').textContent = stars(average);
        summary.querySelector('.panda-reviews__count').textContent =
            (root.dataset.countLabel || '[count]').replace('[count]', reviews.length.toLocaleString('de-DE'));
        summary.hidden = false;

        const withText = reviews
            .filter(function (review) {
                return review.comment && review.comment !== 'null' && String(review.comment).trim();
            })
            .sort(function (a, b) { return new Date(b.creationDate) - new Date(a.creationDate) });

        const grid = root.querySelector('.panda-reviews__grid');
        const more = root.querySelector('.panda-reviews__more');
        let shown = 0;

        function showNext() {
            withText.slice(shown, shown + PAGE_SIZE).forEach(function (review) {
                const card = document.createElement('figure');
                card.className = 'panda-review';
                const rating = document.createElement('div');
                rating.className = 'panda-review__stars';
                rating.textContent = stars(Number(review.mark) || 0);
                rating.setAttribute('aria-label', (Number(review.mark) || 0) + ' / 5');
                const text = document.createElement('blockquote');
                text.className = 'panda-review__text';
                text.textContent = String(review.comment).trim();
                const date = document.createElement('figcaption');
                date.className = 'panda-review__date';
                date.textContent = formatDate(review.creationDate);
                card.append(rating, text, date);
                grid.appendChild(card);
            });
            shown = Math.min(shown + PAGE_SIZE, withText.length);
            more.hidden = shown >= withText.length;
        }

        more.addEventListener('click', showNext);
        showNext();
    });
});

/* ==========================================================================
   PANDA: Gift dialog (sections/panda-gift-dialog.liquid).

   On a page with the dialog, the add-to-cart button of the product form opens
   it instead of adding. The listeners run in the capture phase on window, so
   neither the stock jQuery submit handler nor upsell apps see the event. Liquid renders all
   three steps; this only switches them, fills the preview, prices and summary
   from the inputs, and finally adds the product and the chosen voucher in one
   cart/add request: the voucher is a nested cart line (parent_id), both carry
   the same _gift_key. Posting through jQuery keeps the ajaxSuccess cart
   refresh above working.
   ========================================================================== */
(function () {
    function money(cents) {
        return theme.Shopify.formatMoney(cents, theme.moneyFormat)
    }

    function toggle(element, visible) {
        element.hidden = !visible;
        if ('disabled' in element) { element.disabled = !visible }
    }

    function checked(form, name) {
        return form.querySelector('input[name="' + name + '"]:checked')
    }

    function chosenPlan(form) {
        const plan = checked(form, 'plan');
        if (!plan) { return null }
        return {
            variant: Number(plan.value),
            sellingPlan: plan.dataset.sellingPlan ? Number(plan.dataset.sellingPlan) : null,
            price: Number(plan.dataset.price),
            monthly: plan.dataset.payment === 'monthly',
            text: plan.dataset.label
        }
    }

    function update(dialog) {
        const form = dialog.querySelector('[data-panda-gift-form]');
        const payment = checked(form, 'payment');
        form.querySelectorAll('[data-payment-show]').forEach(function (group) {
            const visible = Boolean(payment) && group.dataset.paymentShow === payment.value;
            group.hidden = !visible;
            group.querySelectorAll('input').forEach(function (input) { input.disabled = !visible })
        });
        const plan = checked(form, 'plan');
        if (payment && (!plan || plan.disabled)) {
            const first = form.querySelector('[data-payment-show="' + payment.value + '"] input:not(:disabled)');
            if (first) { first.checked = true }
        }

        const design = checked(form, 'design');
        if (design) {
            form.querySelectorAll('input[name="format"]:not([value="none"])').forEach(function (input) {
                const price = Number(design.dataset[input.value + 'Price']);
                const compare = Number(design.dataset[input.value + 'Compare']);
                input.disabled = !design.dataset[input.value];
                form.querySelector('[data-format-price="' + input.value + '"]').textContent = input.disabled ? '' : money(price);
                form.querySelector('[data-format-compare="' + input.value + '"]').textContent =
                    !input.disabled && compare > price ? money(compare) : ''
            });
            const current = checked(form, 'format');
            if (current && current.disabled) { form.querySelector('input[name="format"][value="none"]').checked = true }
        }
        const format = checked(form, 'format');
        const formatValue = format ? format.value : 'none';
        const withVoucher = formatValue !== 'none' && Boolean(design);

        form.querySelectorAll('[data-format-show]').forEach(function (element) {
            element.hidden = element.dataset.formatShow !== formatValue
        });
        form.querySelectorAll('[data-voucher-only]').forEach(function (group) { toggle(group, withVoucher) });
        form.querySelectorAll('[data-design-show]').forEach(function (element) {
            element.hidden = !design || element.dataset.designShow !== design.value
        });
        dialog.classList.toggle('is-without-voucher', !withVoucher);

        const personalize = form.querySelector('[data-personalize]');
        const named = withVoucher && Boolean(personalize && personalize.checked);
        const fields = form.querySelector('[data-texts-fields]');
        if (fields) { toggle(fields, named) }
        const tag = form.querySelector('.pgd__tag');
        if (tag) { tag.hidden = !named }

        const extraTexts = Boolean(design && design.hasAttribute('data-extra-texts'));
        const texts = [];
        form.querySelectorAll('[data-text-input]').forEach(function (input) {
            const field = input.closest('.pgd__field');
            const visible = !field.hasAttribute('data-per-design') || extraTexts;
            field.hidden = !visible;
            input.disabled = !named || !visible;
            const line = form.querySelector('[data-text-preview="' + input.dataset.textInput + '"]');
            if (line) {
                line.hidden = !visible;
                line.querySelector('[data-text-value]').textContent = input.value || '…'
            }
            if (named && visible && input.value) { texts.push(input.name.slice(5, -1) + ' ' + input.value) }
        });

        toggle(form.querySelector('[data-panda-gift-shipping]'), formatValue === 'print');
        const target = checked(form, '_gift_voucher_to');

        const product = chosenPlan(form);
        const voucherPrice = withVoucher ? Number(design.dataset[formatValue + 'Price']) : 0;
        const breakdown = form.querySelector('[data-breakdown]');
        form.querySelectorAll('[data-total-label]').forEach(function (label) {
            label.hidden = label.dataset.totalLabel !== (product && product.monthly ? 'plan' : 'once')
        });
        if (product) {
            form.querySelector('[data-total]').textContent = money(product.price + voucherPrice);
            breakdown.textContent = (product.monthly ? breakdown.dataset.labelFirst : breakdown.dataset.labelProduct) + ' ' +
                money(product.price) + (voucherPrice ? ' + ' + breakdown.dataset.labelVoucher + ' ' + money(voucherPrice) : '');
            form.querySelector('[data-sum="plan"]').textContent = product.text;
            form.querySelector('[data-sum="plan-price"]').textContent = money(product.price)
        }

        const recipient = [form.elements._gift_recipient_name.value, form.elements._gift_recipient_city.value].filter(Boolean);
        form.querySelector('[data-sum="recipient"]').textContent = recipient.join(', ');
        form.querySelector('[data-sum-voucher-row]').hidden = !withVoucher;
        if (withVoucher) {
            form.querySelector('[data-sum="voucher"]').textContent =
                design.dataset.title + ', ' + format.closest('.pgd__format').querySelector('.pgd__card-title').textContent;
            form.querySelector('[data-sum="voucher-price"]').textContent = money(voucherPrice);
            form.querySelector('[data-sum="texts"]').textContent = texts.join(', ');
            const delivery = form.querySelector('[data-sum="delivery"]');
            delivery.textContent = formatValue === 'print' && target
                ? target.closest('.pgd__segment').querySelector('[data-target-title]').textContent
                : delivery.dataset.digitalDelivery
        }
        const bonus = form.querySelector('[data-sum-bonus]');
        const bonusPlan = checked(form, 'plan');
        if (bonus) { bonus.hidden = !(bonusPlan && bonusPlan.hasAttribute('data-bonus')) }
    }

    function stepValid(dialog, step) {
        const fields = dialog.querySelectorAll('[data-step="' + step + '"] input, [data-step="' + step + '"] select');
        for (const field of fields) {
            if (!field.checkValidity()) {
                field.reportValidity();
                return false
            }
        }
        return true
    }

    function showStep(dialog, step) {
        dialog.step = step;
        dialog.querySelectorAll('[data-step]').forEach(function (panel) {
            panel.hidden = Number(panel.dataset.step) !== step
        });
        dialog.querySelectorAll('[data-step-go]').forEach(function (button) {
            const n = Number(button.dataset.stepGo);
            if (n === step) { button.setAttribute('aria-current', 'step') } else { button.removeAttribute('aria-current') }
            button.classList.toggle('is-done', n < step)
        });
        const last = dialog.querySelectorAll('[data-step]').length;
        dialog.querySelector('[data-step-back]').hidden = step === 1;
        dialog.querySelector('[data-step-next]').hidden = step === last;
        dialog.querySelector('[data-step-submit]').hidden = step !== last;
        dialog.querySelector('.pgd__body').scrollTop = 0
    }

    function goTo(dialog, step) {
        for (let n = dialog.step; n < step; n++) {
            if (!stepValid(dialog, n)) { return }
        }
        update(dialog);
        showStep(dialog, step)
    }

    function giftItems(dialog) {
        const form = dialog.querySelector('[data-panda-gift-form]');
        const gift = new FormData(form);
        const key = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
        const plan = chosenPlan(form);

        const mainItem = { id: plan.variant, quantity: 1, properties: { _gift_key: key } };
        if (plan.sellingPlan) { mainItem.selling_plan = plan.sellingPlan }

        const design = checked(form, 'design');
        const format = checked(form, 'format');
        const voucherItem = { quantity: 1, parent_id: mainItem.id, properties: { _gift_key: key } };
        if (design && format && format.value !== 'none') { voucherItem.id = Number(design.dataset[format.value]) }
        for (const [name, value] of gift) {
            if (!value) { continue }
            if (name.indexOf('_gift_recipient') === 0) {
                mainItem.properties[name] = value
            } else if (name.indexOf('_gift_voucher') === 0) {
                voucherItem.properties[name] = value
            } else if (name.indexOf('text[') === 0) {
                voucherItem.properties[name.slice(5, -1)] = value
            }
        }
        return voucherItem.id ? [mainItem, voucherItem] : [mainItem]
    }

    function open(evt, productForm) {
        const dialog = document.querySelector('[data-panda-gift-dialog]');
        if (!dialog || !productForm) { return }
        evt.preventDefault();
        evt.stopImmediatePropagation();
        if (!dialog.productForm) {
            const page = dialog.querySelector('input[name="payment"][data-product-id="' + dialog.dataset.pageProduct + '"]');
            if (page) { page.checked = true }
        }
        dialog.productForm = productForm;
        update(dialog);
        showStep(dialog, 1);
        dialog.showModal()
    }

    /* Upsell apps (Candyrack) catch the click on the add-to-cart button and
       add the product themselves, so the dialog has to win the click already:
       window capture runs before their document listeners. The submit
       listener covers Enter in the form. */
    window.addEventListener('click', function (evt) {
        const button = evt.target.closest && evt.target.closest('product-form [data-add-to-cart]');
        if (button) { open(evt, button.form) }
    }, true);

    window.addEventListener('submit', function (evt) {
        if (evt.target.matches('product-form form')) { open(evt, evt.target) }
    }, true);

    $(document).on('input change', '[data-panda-gift-form]', function () {
        update(this.closest('[data-panda-gift-dialog]'))
    });

    $(document).on('click', '[data-panda-gift-close]', function () {
        this.closest('dialog').close()
    });

    $(document).on('click', '[data-step-go]', function () {
        goTo(this.closest('[data-panda-gift-dialog]'), Number(this.dataset.stepGo))
    });

    $(document).on('click', '[data-step-next]', function () {
        const dialog = this.closest('[data-panda-gift-dialog]');
        goTo(dialog, dialog.step + 1)
    });

    $(document).on('click', '[data-step-back]', function () {
        const dialog = this.closest('[data-panda-gift-dialog]');
        showStep(dialog, dialog.step - 1)
    });

    $(document).on('submit', '[data-panda-gift-form]', function (evt) {
        evt.preventDefault();
        const dialog = this.closest('[data-panda-gift-dialog]');
        for (let n = 1; n < dialog.step; n++) {
            if (!stepValid(dialog, n)) { return }
        }
        const $submit = $(this).find('[data-step-submit]').prop('disabled', true);
        const $error = $(this).find('[data-panda-gift-error]').prop('hidden', true);
        $.ajax({
            url: theme.routes.cart_add_url + '.js',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify({ items: giftItems(dialog) })
        }).done(function () {
            window.location = theme.routes.cart_url
        }).fail(function () {
            $error.prop('hidden', false);
            $submit.prop('disabled', false)
        })
    });
})();
